import React, { useRef, useState, useEffect } from "react";
import "./HorizontalScrollingMenu.css";

const HorizontalScrollingMenu = ({ onActiveItemChange, isVisible }) => {
  const [activeItem, setActiveItem] = useState(0);
  const itemRefs = useRef([]);
  const scrollContainerRef = useRef(null);

  const items = [
    "Serie Sigma",
    "Características",
    "Configuraciones",
    "Transporte y aduanas",
    "Instalación y mantenimiento",
    "Asesoramiento",
    "Formación",
    "Accesorios"
  ];  

  useEffect(() => {
    const handleScroll = () => {
      const closestToCenter = itemRefs.current.reduce(
        (closest, item, index) => {
          const box = item.getBoundingClientRect();
          const distance = Math.abs(
            window.innerWidth / 2 - (box.left + box.right) / 2
          );
          if (!closest || distance < closest.distance) {
            return { distance, index };
          }
          return closest;
        },
        null
      );

      setActiveItem(closestToCenter.index);
      onActiveItemChange(closestToCenter.index);
    };

    if (scrollContainerRef.current) {
      scrollContainerRef.current.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [onActiveItemChange]);

  const scrollToItem = (index) => {
    const containerMiddle = scrollContainerRef.current.offsetWidth / 2;
    const itemMiddle = itemRefs.current[index].offsetWidth / 2;
    const scrollLeft =
      itemRefs.current[index].offsetLeft - containerMiddle + itemMiddle;

    scrollContainerRef.current.scrollTo({
      left: scrollLeft,
      behavior: "smooth",
    });
  };

  const handleItemClick = (index) => {
    setActiveItem(index);
    scrollToItem(index);
    onActiveItemChange(index);
  };

  const handlePrevClick = () => {
    const newIndex = activeItem === 0 ? items.length - 1 : activeItem - 1;
    setActiveItem(newIndex);
    scrollToItem(newIndex);
    onActiveItemChange(newIndex);
  };

  const handleNextClick = () => {
    const newIndex = activeItem === items.length - 1 ? 0 : activeItem + 1;
    setActiveItem(newIndex);
    scrollToItem(newIndex);
    onActiveItemChange(newIndex);
  };

  return (
    <div
      className={`horizontal-menu-wrapper ${isVisible ? "visible" : "hidden"}`}
    >
      <button onClick={handlePrevClick} className="scroll-btn prev-btn">
        «
      </button>
      <div className="scroll-container" ref={scrollContainerRef}>
        {items.map((item, index) => (
          <div
            key={index}
            ref={(el) => (itemRefs.current[index] = el)}
            className={`menu-item ${activeItem === index ? "active" : ""}`}
            onClick={() => handleItemClick(index)}
          >
            {item}
          </div>
        ))}
      </div>
      <button onClick={handleNextClick} className="scroll-btn next-btn">
        »
      </button>
    </div>
  );
};

export default HorizontalScrollingMenu;
